const plugins = {};

export default plugins;
